import { FC } from 'react';
import { Outlet, Route, Routes } from 'react-router-dom';
import { ErrorBoundary } from '~/components';
import { ProjectAdminDetail } from './detail';
import { ProjectAdminDetailProps } from './detail/types';
export const ProjectAdminRoutes: FC<ProjectAdminDetailProps> = ({ isListCollapsed }) => {
  return (
    <ErrorBoundary>
      <Routes>
        <Route path=":id/*" element={<ProjectAdminDetail isListCollapsed={isListCollapsed} />} />
      </Routes>
      <Outlet></Outlet>
    </ErrorBoundary>
  );
};
